
export const tedMediaArray = [
  {
    _id: 'tedMediaId1',
    userId: 'tedUserId',
    email: 'ted@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-1.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-1-p.png`,
    description: `A well dressed man smiles to the camera for a professional headshot`,
    captions: [
      `Woke up like this`,
      `Post-coffee me`,
      `My best blue steel`
    ],
    subcaptions: [
      `I'm an architect, wanna check out my skyscraper?`,
      `Not Pictured: My compass and T-square`,
      `Let's pretend I know how to tie a tie`
    ],
    tags: [
      `suit`,
      `smile`,
      `portrait`,
      `face visible`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'tedMediaId2',
    userId: 'tedUserId',
    email: 'ted@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-2.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-2-p.png`,
    description: `A man in a tie sits at a bar looking serious and confused`,
    captions: [
      `Don't judge me`,
      `Caught in the act`,
      `My quarter life crisis looks like`
    ],
    subcaptions: [
      `I swear I wasn't drinking alone at a bar`,
      `I was just asked what 47 x 22 is`,
      `Let's pretend the hoodie is a blazer and the beer is an Aston Martin`
    ],
    tags: [
      `not smiling`,
      `drinks`,
      `face visible`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'tedMediaId3',
    userId: 'tedUserId',
    email: 'ted@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-3.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-3-p.png`,
    description: `A protrait of a man in a sweater and collared shirt looking ponderously at someone out of frame`,
    captions: [
      `Plandid or candid?`,
      `How my friends see me`,
      `Life outtake`
    ],
    subcaptions: [
      `Let's pretend I was playing chess and not entranced by a bar fight.`,
      `Somewhere around serious, too serious, and a total diva`,
      `Watching my friend shotgun a beer... at 33 years old...`
    ],
    tags: [
      `portrait`,
      `face visible`,
      `stylish outfit`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'tedMediaId4',
    userId: 'tedUserId',
    email: 'ted@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-4.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-4-p.png`,
    description: `A young man sitting on a couch, looking somewhat serious or pensive. He has tousled dark hair and is wearing a gray t-shirt with a circular red design that says "RED CROWN." The background appears cozy with some colorful decor.`,
    captions: [
      `Woke up like this`,
      `This could be us`,
      `My life behind the scenes`
    ],
    subcaptions: [
      `Casual vibes only`,
      `Just taking it all in`,
      `Sunday chill mode`
    ],
    tags: [
      `relaxing`,
      `face visible`,
      `not smiling`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'tedMediaId5',
    userId: 'tedUserId',
    email: 'ted@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-5.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-5-p.png`,
    description: `A young man with dark hair looks pensively under a yellow umbrella in the rain, with a city backdrop partially obscured by raindrops on the umbrella.`,
    captions: [
      `Woke up like this`,
      `Life outtake`,
      `Caught in the act`
    ],
    subcaptions: [
      `Weather is just a suggestion`,
      `Rainy days call for introspection`,
      `Under this umbrella, dreams stay dry`
    ],
    tags: [
      `face visible`,
      `urban`,
      `not smiling`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'tedMediaId6',
    userId: 'tedUserId',
    email: 'ted@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-6.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-6-p.png`,
    description: ``,
    captions: [
      `Thank you for coming to my TED Talk`,
      `As seen on my Mom's fridge`,
      `It's all about the simple things`
    ],
    subcaptions: [
      `Casual day, casual vibes`,
      `Just embracing the moment`,
      `Not your average sweater day`
    ],
    tags: [
      `face visible`,
      `smiling`,
      `well dressed`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'tedMediaId7',
    userId: 'tedUserId',
    email: 'ted@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-7.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-7-p.png`,
    description: ``,
    captions: [
      `Me in the wild`,
      `Caught in the act`,
      `I'm known for`
    ],
    subcaptions: [
      `Cheers to a night at the bar with friends!`,
      `I swear I wasn't talking about you.`,
      `Obviously I'm saluting because a soldier walked in`
    ],
    tags: [
      `restaurant`,
      `face visible`,
      `action shot`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'tedMediaId8',
    userId: 'tedUserId',
    email: 'ted@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-8.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-8-p.png`,
    description: `A young man with tousled dark hair is smiling subtly. He is wearing a black sweater over a light blue collared shirt. The background is plain and light-colored, focusing attention on him.`,
    captions: [
      `My uniform`,
      `Me in my blogging days`,
      `As seen on my Mom's fridge`
    ],
    subcaptions: [
      `Good news: You won't have to domesticate me`,
      `Someone you would never suspect of stealing your fries`,
      `'Teddy Bear' Mosby has never been a nickname`
    ],
    tags: [
      `smiling`,
      `face visible`,
      `portrait`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'tedMediaId9',
    userId: 'tedUserId',
    email: 'ted@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-9.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-9-p.png`,
    description: `A man stands in front of a backdrop with the word 'MacLaren's' visible. He has curly dark hair, a serious expression, and is wearing a tie. His attire appears casual but includes a hoodie and jacket.`,
    captions: [
      `Dating me will look like`,
      `Pre-coffee me`,
      `Don't judge me`
    ],
    subcaptions: [
      `Just your average day at work`,
      `When life takes you by surprise`,
      `Double shot please`
    ],
    tags: [
      `face visible`,
      `portrait`,
      `not smiling`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'tedMediaId10',
    userId: 'tedUserId',
    email: 'ted@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-10.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-10-p.png`,
    description: ``,
    captions: [
      `I thought I deleted this one`,
      `How my friends see me`,
      `Dating me will look like`
    ],
    subcaptions: [
      `Yes, the armchair is included`,
      `I didn't swallow a lemon, this is just my 'listening' face`,
      `You're in luck, you've finally found the pretentious prick you've been looking for`
    ],
    tags: [
      `well dressed`,
      `sitting`,
      `not smiling`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'tedMediaId11',
    userId: 'tedUserId',
    email: 'ted@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-11.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-11-p.png`,
    description: ``,
    captions: [
      `Don't judge me`,
      `My uniform`,
      `Caught in the act`
    ],
    subcaptions: [
      `Cheers to our future together`,
      `Just vibing`,
      `Note to self: Don't order 'extra foamy' next time`
    ],
    tags: [
      `restaurant`,
      `beverage`,
      `casual`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'tedMediaId12',
    userId: 'tedUserId',
    email: 'ted@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-12.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-12-p.png`,
    description: `A man with curly dark hair wearing a beige blazer over a white shirt and a purple tie. He is smiling and pointing at something, sitting in a brightly lit room with plants in the background.`,
    captions: [
      `My uniform`,
      `I feel famous when`,
      `It was all fun and games until`
    ],
    subcaptions: [
      `This guy!`,
      `Have you met...`,
      `Skilled at gracefully exiting smalltalk`
    ],
    tags: [
      `smiling`,
      `well dressed`,
      `action shot`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'tedMediaId13',
    userId: 'tedUserId',
    email: 'ted@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-13.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-13-p.png`,
    description: ``,
    captions: [
      `My life behind the scenes`,
      `Life outtake`,
      `Post-coffee me`
    ],
    subcaptions: [
      `Just chilling`,
      `Something was funny I swear`,
      `Warning: Will laugh at stupid jokes`
    ],
    tags: [
      `smiling`,
      `sitting`,
      `relaxed`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'tedMediaId14',
    userId: 'tedUserId',
    email: 'ted@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-14.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-14-p.png`,
    description: ``,
    captions: [
      `#MondaysAmIRight?`,
      `My uniform`,
      `Caught in the act`
    ],
    subcaptions: [
      `When you catch your students smoking weed in the back row`,
      `It's OK Gerald, there are no stupid questions`,
      `Sudden realization mid-sentence`
    ],
    tags: [
      `professional`,
      `serious`,
      `suit`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  }
]